export const environment = {
  production: true,
  version: 'a53a29b846',
  site_version: 'SITE_VERSION'
};
